import { Services } from '@sigma-frontend-libs/commons'

import { permissionPresets, proxy } from '@/utils'

import render from './render'

export default {
  name: 'TemplatesFilter',

  mixins: [ proxy({ type: 'object' }) ],

  computed: {
    canGetUsers() {
      return this.checkPermissions(`advanced.${Services.users}.get`, permissionPresets.resellerUp)
    }
  },

  render
}
